import { render, staticRenderFns } from "./lazyblock_events.vue?vue&type=template&id=90233d04&scoped=true"
import script from "./lazyblock_events.vue?vue&type=script&lang=js"
export * from "./lazyblock_events.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_events.vue?vue&type=style&index=0&id=90233d04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90233d04",
  null
  
)

export default component.exports